import { cn } from '@/lib/utils';
import type { RecallTopicId } from '@rock/types';
import { X } from 'lucide-react';
import type { FC } from 'react';

/**
 * One recall topic, as a violet chip titled for the admin (a topic's title is how it is read; its id shows on
 * hover). `onRemove` turns it into a removable pill. An id with no topic doc behind it shows as the id.
 */
export const RecallTopicBadge: FC<{
    topicId: RecallTopicId;
    title?: string;
    onRemove?: () => void;
    removeLabel?: string;
    className?: string;
    labelClassName?: string;
}> = ({ topicId, title, onRemove, removeLabel, className, labelClassName }) => (
    <span
        className={cn(
            'inline-flex items-center gap-1 rounded-full bg-violet-100 px-2.5 py-0.5 text-xs font-medium text-violet-800',
            className,
        )}
        title={title ? topicId : undefined}
    >
        <span className={labelClassName}>{title ?? topicId}</span>
        {onRemove && (
            <button type="button" aria-label={removeLabel ?? `Remove topic ${title ?? topicId}`} onClick={onRemove}>
                <X className="h-3 w-3" />
            </button>
        )}
    </span>
);
